import React from "react"
import { useContext, useEffect, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { FeatureCatalogContext } from "../../../../../../features/FeatureCatalogViewer/FeatureCatalogProvider"
import "./affiliation.scss"

interface IFeaturetypeSimple {
  featuretypeId?: number
  featuretypeName?: string
}

const Affiliation = () => {
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog, type, pid } = useParams<{ catalog: string; type: string; pid: string }>()
  const [children, setChildren] = useState(new Array<IFeaturetypeSimple>())
  const [parents, setParents] = useState(new Array<IFeaturetypeSimple>())

  useEffect(() => {
    const getAffiliation = async () => {
      if (!pid) {
        return
      }
      if (type === "featureType") {
        const childList = new Array<IFeaturetypeSimple>()
        const parentList = new Array<IFeaturetypeSimple>()
        context.elementDetails?.associations?.map(
          (association: { isParentAssociation: any; featureType: { featureTypeId: any; featureTypeName: any } }) => {
            if (association.isParentAssociation) {
              parentList.push({
                featuretypeId: association.featureType?.featureTypeId,
                featuretypeName: association.featureType?.featureTypeName
              })
            } else {
              childList.push({
                featuretypeId: association.featureType?.featureTypeId,
                featuretypeName: association.featureType?.featureTypeName
              })
            }
          }
        )
        setChildren(childList)
        setParents(parentList)
      }
    }

    getAffiliation()
  }, [context.elementDetails])

  return (
    <div>
      <ul className="list-group list-group-borderless">
        <li className="list-group-item card-subtitle-2" id="headerInPanel">
          ASSOCIATION
        </li>
        <div className="affiliationDivider">
          <div className="leftColumn">
            <ul className="list-group list-group-borderless bg-white">
              <li className="list-group-item card-text" id="header">
                Parents
              </li>
              {parents.map((parent) => {
                const onClick = () => {
                  context.setAtId(null)
                  context.setTypeDisplayName(parent.featuretypeName!)
                  context.updateHistory(history, catalog, "featureType", "" + parent.featuretypeId!)
                }
                return (
                  <li
                    onClick={onClick}
                    className="list-group-item card-text-1 text-primary"
                    key={parent.featuretypeId}
                    id="color"
                  >
                    <div className="pr-3">
                      <span className="nameString">{parent.featuretypeName} </span>
                      <span className="badge badge-sm badge-text-secondary">{parent.featuretypeId}</span>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="rightColumn">
            <ul className="list-group list-group-borderless">
              <li className="list-group-item card-text" id="header">
                Children
              </li>
              {children.map((child) => {
                const onClick = () => {
                  context.setAtId(null)
                  context.setTypeDisplayName(child.featuretypeName!)
                  context.updateHistory(history, catalog, "featureType", "" + child.featuretypeId!)
                }
                return (
                  <li
                    onClick={onClick}
                    className="list-group-item card-text-1 text-primary"
                    key={child.featuretypeId}
                    id="color"
                  >
                    <div className="pr-3">
                      <span className="nameString">{child.featuretypeName} </span>
                      <span className="badge badge-sm badge-text-secondary">{child.featuretypeId}</span>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </ul>
    </div>
  )
}

export default Affiliation
